import { useEffect } from "react";
import { CardFrame } from "../../../../../common/components/card-frame/CardFrame";
import { MainValue, MainValueTextSize } from "../../../../../common/components/main-value/MainValue";
import { useLazyGetLastPurchaseQuery } from "../../../../../service/vending-service";
import { PrepaidLastPurchaseCardSkeleton } from "./PrepaidLastPurchaseCardSkeleton";
import styles from "./prepaid-last-purchase-card.module.scss";

export const PrepaidLastPurchaseCard = () => {
	const [fetch, { data, isFetching, isUninitialized }] = useLazyGetLastPurchaseQuery();

	useEffect(() => { fetch(); }, [fetch]);

	if (isFetching || isUninitialized) return <PrepaidLastPurchaseCardSkeleton />;

	return (
		<div className={styles.row}>
			<div className={styles.cardWrapper}>
				<CardFrame>
					<div className={styles.card}>
						<span className={styles.label}>Last Purchase</span>
						<MainValue value={data?.lastPurchase} unit="Units" textSize={MainValueTextSize.Large} />
					</div>
				</CardFrame>
			</div>
			<div className={styles.cardWrapper}>
				<CardFrame>
					<div className={styles.card}>
						<span className={styles.label}>Units Remaining</span>
						<MainValue value={data?.unitRemaining} unit="Units" textSize={MainValueTextSize.Large} />
					</div>
				</CardFrame>
			</div>
		</div>
	);
};
